import { FC, useState } from 'react'
import { Card, Stack } from '@instabox/consumer-web-ui'
import { getTranslation } from '@instabox/consumer-web-shared'

import CategoryTitle from './CategoryTitle'
import CollapsibleSubCategory from './CollapsibleSubCategory'
import FAQList from '../FAQList'
import { CategoryWithFaqs } from '../../types'

const OTHER_SLUG = 'other'

const FAQCategory: FC<CategoryWithFaqs> = ({
  subCategories,
  faqs,
  translations,
  name,
  icon,
  slug,
}) => {
  const [expandedItems, setExpandedItems] = useState<string[]>([])

  const toggleItem = (id: string) => {
    if (expandedItems.includes(id)) {
      setExpandedItems(expandedItems => expandedItems.filter(expandedItem => expandedItem !== id))
    } else {
      setExpandedItems(expandedItems => [...expandedItems, id])
    }
  }

  return (
    <Card>
      <CategoryTitle icon={icon} slug={slug !== OTHER_SLUG ? slug : null}>
        {getTranslation('name', translations, name)}
      </CategoryTitle>
      <Stack>
        {subCategories?.map(({ id, name, faqs, translations }) => (
          <CollapsibleSubCategory
            key={id}
            label={getTranslation('name', translations, name)}
            expanded={expandedItems.includes(id)}
            onToggle={() => toggleItem(id)}>
            <FAQList faqs={faqs} animateInitial />
          </CollapsibleSubCategory>
        ))}
        <FAQList faqs={faqs} />
      </Stack>
    </Card>
  )
}

export default FAQCategory
